export default __webpack_public_path__ + "static/media/fullcycle.b83cb670.svg";